import * as Utils from './utils';
import * as Maps from './maps';
import * as Freeform from './freeform';
import * as Toggles from './toggles';
import axios from 'axios';
import imagesLoaded from 'imagesloaded';

const body = document.querySelector('body'),
    pageLoader = document.querySelector('.js-app-page-loader'),
    page = document.querySelector('.js-app-page'),
    pageContainer = document.querySelector('.js-app-page-overlay'),
    pageContents = document.querySelector('.js-app-page-content'),
    closeTriggers = document.querySelectorAll('.js-close-app-page-trigger'),
    windowHistoryAPI = !!(window.history && history.pushState),
    basePath = body.dataset.basepath,
    rootPath = body.dataset.rootpath;

export const previousUrls = [];
export const pathSegmentMatches = [
    /^\/people\/[A-Za-z0-9-]+/,
    // /^\/news-events\/[A-Za-z0-9-]+/,
    /^\/courses\/pathway\/[A-Za-z0-9-]+/,
];

let prevScrollTop = 0,
    overlayTransitionTime = 500,
    closedUrl = '';

export function init() {
    if (windowHistoryAPI) {
        setUpAppLinks();
    }
}

function setUpAppLinks() {
    // Abort if on IE
    if (Utils.browserDetection.ie) {
        return false;
    }

    // Register overlay elements
    let overlayElements = [pageContainer];

    // When clicking a close link
    body.addEventListener('click', e => {
        if (Utils.matches(e.target, '.js-close-app-page-trigger, .js-close-app-page-trigger *')) {
            // Only run this if page was opened as app page,
            // not landed here
            if (body.classList.contains('app-open')) {
                e.stopPropagation();
                e.preventDefault();

                window.history.back();
            }
        }
    });

    // On popstate, parse it
    window.addEventListener('popstate', e => {
        let targetUrl = basePath,
            uri = '',
            match = false;

        // Check if going back to an App Page in array
        if (Array.isArray(previousUrls) && previousUrls.length) {
            // Target URL should be the last item in the previous Url array
            targetUrl = previousUrls.slice(-1)[0];
            uri = new URL(targetUrl).pathname;
            
            // Remove last item from previousUrls array
            previousUrls.pop();

            // Are we going back to a previous app page?
            for (let i = 0; i < pathSegmentMatches.length; i++) {
                if (pathSegmentMatches[i].test(uri)) {
                    match = true;
                }
            }

            if (match) {
                // Track it in GA
                if (typeof ga !== 'undefined') {
                    ga('send', 'pageview', targetUrl);
                }

                // Load the page contents
                loadPage(targetUrl);

                return;
            }
        }

        // Check if we're going forwards to an App page
        targetUrl = window.location.href;
        uri = new URL(targetUrl).pathname;

        // Make sure this is an App page
        for (let i = 0; i < pathSegmentMatches.length; i++) {
            if (pathSegmentMatches[i].test(uri)) {
                match = true;
            }
        }

        if (match) {
            // Track it in GA
            if (typeof ga !== 'undefined') {
                ga('send', 'pageview', targetUrl);
            }

            // Load the page contents
            loadPage(targetUrl);

            return;
        }

        // Otherwise, assume we're closing the App page via popstate
        closePage();
    });

    // Don't allow body scrolls on scrolling page loader
    pageLoader.addEventListener(
        'mousewheel  DOMMouseScroll  MozMousePixelScroll  ' + Utils.touchMoveClasses,
        e => {
            e.preventDefault();
        }
    );

    if (Utils.browserDetection.iOS) {
        body.classList.add('fix-ios-overlay-scroll');
    }
}

export function loadPage(pageUrl) {
    var requestTime = Date.now();

    // Only do this if we are not in an app page currently
    if (!page.classList.contains('reveal')) {
        // Get the current scroll top and left values
        prevScrollTop = Utils.getScrollTop();
    } else {
        // We already have an app page open so
        // lets hide the contents of the old page
        // until the new contents are loaded in
        page.classList.remove('reveal');
    }

    if (prevScrollTop) {
        // Maintain the scroll position of the body
        // useful for when popstate is called which natively umps viewport
        // back to top of the page
        window.scrollTo(0, prevScrollTop);
    }

    // Show the loading overlay
    pageLoader.classList.add('reveal');

    // Get overlay elements
    let overlayElements = [pageContainer];

    // Show the overlay elements
    showOverlay(overlayElements);

    // When the overlay is fully transitioned in
    setTimeout(function() {
        // Scroll to the top of the container so the loading icon is visible
        pageContainer.scrollTop = 0;
    }, overlayTransitionTime);

    // Request the page
    axios
        .get(pageUrl, {
            headers: { 'X-Requested-With': 'XMLHttpRequest' },
        })
        .then(function(response) {
            showPage(response.request.response, requestTime);
        })
        .catch(function(error) {
            console.error(error);
        });
}

function showPage(contents, requestTime) {
    // Convert string to nodes so we can find main content
    let contentHTML = stringToHTML(contents),
        mainContent = contentHTML.querySelector('.js-main-content');

    setPageContents(mainContent);

    // Reset images to avoid weird Safari bug
    if (Utils.browserDetection.safari || Utils.browserDetection.iOS) {
        let imgs = mainContent.getElementsByTagName('img');

        for (let i = 0; i < imgs.length; i++) {
            imgs[i].outerHTML = imgs[i].outerHTML;
        }
    }

    // When all the images have loaded, fade it in
    imagesLoaded(pageContents, () => {
        // Wait until the overlay is fully showing, adding 16ms to make
        // sure this runs after the loadingIcons have been given 'reveal'.
        // This may be an issue with the accuracy of Date.now()?
        setTimeout(() => {
            // Set the flow of the page
            body.classList.add('flow-switch');

            // Scroll to Top of new page
            window.scroll(0, 0);

            // Hide the loader
            pageLoader.classList.remove('reveal');

            // Show the page
            page.classList.add('reveal');

            // Toggle Buttons
            Toggles.init();

            // FreeForm
            if (document.querySelectorAll('.js-freeform')) {
                Freeform.init();
            }

            // Detect map within page
            if (page.querySelector('.js-map')) {
                const mapEl = page.querySelector('.js-map');

                // Test whether Maps API is already loaded
                if (typeof google !== 'undefined') {
                    // Build map
                    Maps.buildEventMap(mapEl);
                } else {
                    // Load the API script
                    loadJS("https://maps.googleapis.com/maps/api/js?key=AIzaSyC5uWs0-Fiok924jYFXd3SRUokcVD5kkeI");

                    // Set check running
                    let mapsCheck = setInterval(function(){
                        if (typeof google === 'object' && typeof google.maps === 'object') {
                            // Build map
                            Maps.buildEventMap(mapEl);

                            // Break interval
                            clearInterval(mapsCheck);
                        }
                    }, 100);
                }
            }

            // Run element transitions
            Utils.animateInViewEls('.js-watch', 'in-view', 0.075);
        }, Math.max(overlayTransitionTime - (Date.now() - requestTime) + 16, 0));
    });
}

function setPageContents(contents, erase) {
    pageContents.innerHTML = '';
    
    if (!erase) {
        // Insert contents into the container
        pageContents.appendChild(contents);
    }
}

function closePage() {
    var scrollTop = Utils.getScrollTop();

    // Set the flow to the body
    body.classList.remove('flow-switch');

    // Maintain the scroll position of the app page container now that the
    // flow has been set back to the body to avoid a jump
    pageContainer.scrollTop = scrollTop;

    setTimeout(() => {
        // Restore the scroll position of the body
        window.scrollTo(0, prevScrollTop);

        // Remove the reveal class
        page.classList.remove('reveal');

        // Clear the app page contents so the overlay is empty next time
        setPageContents('', true);

        // Get overlay elements
        let overlayElements = [pageContainer];

        // Hide the overlay
        hideOverlay(overlayElements);
    }, overlayTransitionTime + 64);
}

function showOverlay(overlays) {
    [...overlays].forEach(el => {
        el.classList.add('reveal');
    });

    body.classList.add('app-open');
}

function hideOverlay(overlays) {
    [...overlays].forEach(el => {
        el.classList.remove('reveal');
    });

    body.classList.remove('app-open');
}

function parserSupport() {
    if (!window.DOMParser) return false;
    var parser = new DOMParser();
    try {
        parser.parseFromString('x', 'text/html');
    } catch (err) {
        return false;
    }
    return true;
}

function stringToHTML(str) {
    // If DOMParser is supported, use it
    if (parserSupport()) {
        var parser = new DOMParser();
        var doc = parser.parseFromString(str, 'text/html');
        return doc.body;
    }

    // Otherwise, fallback to old-school method
    var dom = document.createElement('div');
    dom.innerHTML = str;
    return dom;
}
